import { combineReducers } from "redux";
import { signIn } from "./signIn.reducer";
import { matterDetails } from "./matter.reducer";
import { correspondence } from "./correspondance.reducer";
import { client } from "./clientAddress.reducer";


const appReducers = combineReducers({
    signIn,
    matterDetails,
    correspondence,
    client
});

const rootreducer = (state, action) => {
    return appReducers(state, action);
};

export default rootreducer;
